import React from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import { ScrollToTop } from '@futurefamily/ef-components';
import { TreatmentOptions } from './modules/treatment-options';
import { PaymentOptions } from './modules/payment-options';
import AppLayout from './components/AppLayout';
import routes from './constants/routes';
import * as config from './config';

function App () {
  return (
    <BrowserRouter basename={config.BASENAME}>
      <ScrollToTop />

      <AppLayout>
        <Switch>
          <Route path={routes.paymentOptions} component={PaymentOptions} />
          <Route exact path={routes.treatmentOptions} component={TreatmentOptions} />
          <Route path="*">
            <Redirect to={routes.treatmentOptions} />
          </Route>
        </Switch>
      </AppLayout>
    </BrowserRouter>
  );
}

export default App;
